module.exports = __webpack_public_path__ + "static/media/thumbnail.6de0e2d6.png";